import { yoga } from "../assets";
import { getOrganizationLogo } from "../assets/logos";

const ProfessionalCredentials = () => {
    // Current Positions
    const currentPositions = [
        {
            id: 1,
            title: "Vice Chancellor",
            institution: "Sampurnanand Sanskrit University",
            location: "Varanasi, Uttar Pradesh",
            period: "Current",
            description: "Leading one of the world's largest Sanskrit universities with a 234+ year legacy, elevating it into an international bastion of learning",
            icon: "🏛️",
            isHighlight: true
        },
        {
            id: 2,
            title: "Member, Governing Council",
            institution: "Centre for Yogic Sciences (IUC-YS)",
            location: "Inter-University Centre",
            period: "Current",
            description: "Nominated by the Chairman, University Grants Commission (UGC) for a three-year term. Contributing to strategic guidance, policy inputs, and long-term institutional development.",
            icon: yoga,
            type:"img",
            isHighlight: true
        },
        {
            id: 3,
            title: "Trustee",
            institution: "Shri Kashi Vishwanath Mandir Varanasi",
            location: "Varanasi, Uttar Pradesh",
            period: "Current",
            description: "Associated with the governance and advisory framework of one of India's most sacred and culturally significant temple trusts.",
            icon: "🕉️",
            isHighlight: true
        },
         {
            id: 4,
            title: "Member, Governing Council",
            institution: "Jagadguru Rambhadracharya Divyang University",
            location: "Chitrakoot, Uttar Pradesh",
            period: "Current",
            description: "Contributing to statutory governance, academic planning, and policy decisions of a nationally recognized specialized university.",
            icon: "🎓",
            isHighlight: true
        },
    ];

    // Major Administrative Positions
    const majorPositions = [
        {
            id: 3,
            title: "Member, Higher Education Council",
            institution: "Government of Madhya Pradesh",
            location: "Madhya Pradesh",
            period: "Administrative Role",
            description: "Nominated by the State Government to contribute to policy formulation, academic planning, regulation, and overall development of higher education institutions in Madhya Pradesh.",
            icon: "🏛️",
            category: "Policy & Planning"
        },
        {
            id: 4,
            title: "Director, Internal Quality Assurance Cell (IQAC)",
            institution: "Shri Lal Bahadur Shastri National Sanskrit University",
            location: "New Delhi",
            period: "Extended Tenure",
            description: "Overseeing accreditation, quality benchmarks, academic audits, and continuous institutional improvement.",
            icon: "🏛️",
            category: "Quality Assurance"
        },
        {
            id: 5,
            title: "Chairperson, Management Committee",
            institution: "Shri Bhagwan Das Adarsh Sanskrit Mahavidyalaya",
            location: "Haridwar, Uttarakhand",
            period: "Leadership Role",
            description: "Providing academic and administrative leadership, overseeing institutional governance, policy implementation, and strategic development of the college.",
            icon: "🏛️",
            category: "Institutional Leadership"
        },
        {
            id: 6,
            title: "Chief Proctor",
            institution: "Shri Lal Bahadur Shastri National Sanskrit University",
            location: "New Delhi",
            period: "Administrative Role",
            description: "Responsible for campus discipline, student welfare, and administrative coordination.",
            icon: "🏛️",
            category: "Campus Administration"
        },
        {
            id: 7,
            title: "Chairperson, Management Committee",
            institution: "Rani Padmavati Tara Yog Tantra Adarsh Sanskrit Mahavidyalaya",
            location: "Shivpur, Varanasi",
            period: "Academic Leadership",
            description: "Providing academic oversight, administrative leadership, and strategic guidance for institutional growth and quality enhancement.",
            icon: "🏫",
            category: "Educational Leadership"
        },
        {
            id: 8,
            title: "Deputy Coordinator – UGC SAP DRS-I, DRS-II & DRS-III (Jyotish)",
            institution: "University Grants Commission (UGC)",
            location: "New Delhi",
            period: "Multi-phase Programme",
            description: "Led multi-phase national research programmes strengthening advanced research infrastructure, faculty development, and doctoral scholarship in Jyotish.",
            icon: "🏛️",
            category: "Research Leadership"
        },
        {
            id: 9,
            title: "Vice-President",
            institution: "Sanskrit Bharti, Delhi",
            location: "Delhi",
            period: "Leadership Position",
            description: "Providing leadership and strategic direction to a nationally reputed organization dedicated to the promotion, preservation, and propagation of Sanskrit language and culture.",
            icon: "🏛️",
            category: "Cultural Leadership"
        },
        {
            id: 10,
            title: "Member, Governing Council",
            institution: "Jagadguru Rambhadracharya Divyang University",
            location: "Chitrakoot, Uttar Pradesh",
            period: "Statutory Position",
            description: "Contributing to statutory governance, academic planning, and policy decisions of a nationally recognized specialized university.",
            icon: "🎓",
            category: "University Governance"
        },
        
        {
            id: 11,
            title: "Academic Representative",
            institution: "Kumbh Conclave 2024–25",
            location: "National Level",
            period: "2024-25",
            description: "Representing academic perspectives in a national-level conclave focusing on cultural, spiritual, and knowledge traditions.",
            icon: "🌟",
            category: "Cultural Representation"
        }
    ];

    // Selection Committee & Board Memberships
    const committeeMemberships = [
        {
            id: 8,
            title: "Expert Member, Selection Committee",
            institution: "Himachal Pradesh Public Service Commission",
            description: "Participated in faculty recruitment and academic evaluation through public service commission processes.",
            
            
        },
        {
            id: 9,
            title: "Expert Member, Selection Committee",
            institution: "Banaras Hindu University (BHU)",
            description: "Served as subject expert for faculty recruitment, ensuring merit-based academic appointments.",
            
           
        },
        {
            id: 10,
            title: "Expert Member, Selection Committee",
            institution: "Bihar State University Service Commission",
            description: "Contributed as subject expert in statutory selection and appointment of university teachers.",
            
        },
        {
            id: 16,
            title: "Member, Board of Studies",
            institution: "Jawaharlal Nehru University, New Delhi",
            description: "Provided expert input for curriculum design, syllabus revision, and academic standards.",
            
        },
        {
            id: 11,
            title: "Expert Member, Selection Committee",
            institution: "Odisha Adarsha Vidyalaya Sangathan",
            description: "Served as expert member for teacher selection and academic quality assurance.",
            
        },
        {
            id: 12,
            title: "Member, Academic Council (Vidvat Parishad)",
            institution: "Shri Lal Bahadur Shastri National Sanskrit University",
            description: "Participated in academic policy formulation, curriculum approval, and research governance.",
            
        },
        {
            id: 13,
            title: "Member, University Research Development Committee (URDC)",
            institution: "Uttarakhand Sanskrit University, Haridwar",
            description: "Contributed to research policy formulation, project evaluation, and promotion of academic research.",
            
        },
        {
            id: 14,
            title: "Member, Planning Board",
            institution: "Maharishi Valmiki Sanskrit University, Kaithal, Haryana",
            description: "Participated in institutional planning and long-term academic development strategies.",
            
        },
        {
            id: 15,
            title: "Member, Selection Committee",
            institution: "Rashtriya Sanskrit Sansthan, New Delhi",
            description: "Contributed to appointment and promotion of academic staff in Sanskrit institutions.",
            
        },
        
        {
            id: 17,
            title: "Member, Board of Studies",
            institution: "Central Sanskrit University, New Delhi",
            description: "Contributed to subject development, curriculum framing, and academic quality assurance.",
            
        },
        {
            id: 18,
            title: "Member, Board of Course Committee",
            institution: "Guru Nanak Dev University, Amritsar",
            description: "Advised on course content, academic structure, and syllabus development.",
            
        },
        {
            id: 19,
            title: "Member, Board of Studies",
            institution: "Mewar University, Chittorgarh, Rajasthan",
            description: "Advised on curriculum development and academic structuring in Jyotish and Sanskrit studies.",
            
        },
        {
            id: 20,
            title: "Member, Selection Committee",
            institution: "Magadh University, Bodhgaya",
            description: "Participated in faculty recruitment and academic assessment processes.",
            
        },
        {
            id: 21,
            title: "Member, Selection Committee",
            institution: "Laxmi Devi Shroff Adarsh Sanskrit Mahavidyalaya, Deoghar, Jharkhand",
            description: "Served as expert member for faculty selection.",
            
        },
        {
            id: 22,
            title: "Member, Working Committee",
            institution: "Kalidas Samiti, Ujjain",
            description: "Participating in planning and execution of academic and cultural programmes dedicated to the legacy of Mahakavi Kalidasa.",
            
        }
    ];

    const statistics = [
        { label: "Current Positions", value: "4", description: "Vice Chancellor, IUC-YS Member, Trustee & Member, Governing Council" },
        { label: "Total Positions", value: "35+", description: "Across Multiple Institutions" },
        { label: "Selection Committees", value: "8+", description: "Expert Member Roles" },
        { label: "Board Memberships", value: "6+", description: "Academic & Planning Boards" }
    ];

    return (
        <section id="credentials" className="py-16 bg-gradient-to-br from-heritage-ivory to-secondary-50">
            <div className="container mx-auto px-4 max-w-7xl">
                {/* Section Header */}
                <div className="text-center mb-12">
                    <h2 className="text-display-md font-serif text-heritage-maroon mb-4">
                        Professional Credentials & Academic Leadership
                    </h2>
                    <p className="text-heading-sm text-secondary-600 max-w-4xl mx-auto">
                        Extensive academic leadership spanning multiple prestigious institutions, with expertise in Sanskrit studies, 
                        quality assurance, research coordination, and educational administration across India.
                    </p>
                </div>

                {/* Statistics Display */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
                    {statistics.map((stat, index) => (
                        <div 
                            key={index}
                            className="text-center p-6 bg-white rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105 flex flex-col items-center justify-center min-h-[140px]"
                        >
                            <div className="text-3xl font-bold text-primary-500 mb-2">
                                {stat.value}
                            </div>
                            <div className="text-sm font-semibold text-secondary-700 mb-1">
                                {stat.label}
                            </div>
                            <div className="text-sm text-secondary-500 line-clamp-2">
                                {stat.description}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Current Positions - Highlighted */}
                <div className="mb-16">
                    <div className="text-center mb-12">
                        <h3 className="text-display-sm font-serif text-heritage-maroon mb-4">
                            Current Leadership Positions
                        </h3>
                        <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-accent-500 mx-auto mb-4"></div>
                        <p className="text-secondary-600 max-w-2xl mx-auto">
                            Active leadership roles driving academic excellence and cultural preservation
                        </p>
                    </div>
                    
                    <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto">
                        {currentPositions.map((position) => (
                            <div 
                                key={position.id}
                                className="relative p-8 rounded-3xl bg-gradient-to-br from-heritage-gold/10 via-primary-50 to-accent-50 border-2 border-heritage-gold/30 transition-all duration-300 hover:scale-105 hover:shadow-heritage group"
                            >
                                {/* Decorative Background Pattern */}
                                <div className="absolute inset-0 opacity-5 rounded-3xl overflow-hidden">
                                    <div className="absolute top-4 right-4 w-32 h-32 bg-heritage-gold rounded-full transform rotate-12"></div>
                                    <div className="absolute bottom-4 left-4 w-24 h-24 bg-primary-500 rounded-full transform -rotate-12"></div>
                                </div>
                                
                                {/* Current Position Badge */}
                                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-heritage-gold to-primary-500 text-white px-4 py-2 rounded-full text-xs font-bold shadow-strong transform group-hover:scale-110 transition-transform duration-300 z-30">
                                    <span className="flex items-center">
                                        <span className="w-1.5 h-1.5 bg-white rounded-full mr-1.5 animate-pulse"></span>
                                        Current
                                    </span>
                                </div>

                                {/* Icon Container */}
                                <div className="relative z-10 mb-6">
                                    <div className="w-16 h-16 bg-white rounded-2xl shadow-soft flex items-center justify-center mb-4 group-hover:shadow-medium transition-shadow duration-300">
                                        {position.type === "img" ? 
                                            <img src={position.icon} alt={position.institution} className="w-10 h-10 object-contain"/> : 
                                            (() => {
                                                const logo = getOrganizationLogo(position.institution);
                                                if (typeof logo === 'object' && logo.type === 'image') {
                                                    return <img src={logo.src} alt={logo.alt} className="w-10 h-10 object-contain"/>;
                                                }
                                                return <span className="text-3xl">{logo}</span>;
                                            })()
                                        }
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="relative z-10">
                                    <h4 className="text-heading-lg font-serif text-heritage-maroon mb-3 leading-tight">
                                        {position.title}
                                    </h4>
                                    
                                    <div className="text-primary-600 font-bold mb-2 text-lg">
                                        {position.institution}
                                    </div>
                                    
                                    <div className="flex items-center text-secondary-500 text-sm mb-4">
                                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        {position.location}
                                        <span className="mx-2">•</span>
                                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        {position.period}
                                    </div>
                                    
                                    <div className="bg-white/60 rounded-xl p-4 backdrop-blur-sm">
                                        <p className="text-secondary-700 leading-relaxed text-sm">
                                            {position.description}
                                        </p>
                                    </div>
                                </div>

                                {/* Decorative Corner Element */}
                                <div className="absolute bottom-4 right-4 w-8 h-8 bg-gradient-to-br from-heritage-gold/20 to-primary-200/20 rounded-full opacity-50 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Major Administrative Positions */}
                <div className="mb-16">
                    <h3 className="text-heading-lg font-serif text-heritage-maroon mb-8 text-center">
                        Major Administrative & Leadership Roles
                    </h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        {majorPositions.map((position) => (
                            <div 
                                key={position.id}
                                className="relative p-6 rounded-2xl bg-white shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105"
                            >
                                {/* Category Badge */}
                                <div className="absolute -top-2 -right-2 bg-accent-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                    {position.category}
                                </div>

                                {/* Icon */}
                                <div className="text-4xl mb-4">
                                    {(() => {
                                        const logo = getOrganizationLogo(position.institution);
                                        if (typeof logo === 'object' && logo.type === 'image') {
                                            return <img src={logo.src} alt={logo.alt} className="w-16 h-16 object-contain"/>;
                                        }
                                        return logo;
                                    })()}
                                </div>

                                {/* Content */}
                                <h4 className="text-heading-sm font-serif text-heritage-maroon mb-2 leading-tight">
                                    {position.title}
                                </h4>
                                
                                <div className="text-primary-600 font-semibold mb-1 text-sm">
                                    {position.institution}
                                </div>
                                
                                <div className="text-secondary-500 text-xs mb-3">
                                    {position.location} • {position.period}
                                </div>
                                
                                <p className="text-secondary-600 leading-relaxed text-sm">
                                    {position.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Selection Committees & Board Memberships */}
                <div className="mb-16">
                    <h3 className="text-heading-lg font-serif text-heritage-maroon mb-8 text-center">
                        Selection Committees & Board Memberships
                    </h3>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {committeeMemberships.map((membership) => (
                            <div 
                                key={membership.id}
                                className="p-6 rounded-xl bg-white shadow-soft hover:shadow-medium transition-all duration-300 hover:scale-105"
                            >
                                {/* Icon */}
                                <div className="text-3xl mb-3">
                                    {membership.type === "img" ? 
                                        <img src={membership.icon} alt={membership.institution} className={"w-10 h-10 object-contain"}/> : 
                                        membership.icon ? 
                                            <span>{membership.icon}</span> :
                                            (() => {
                                                const logo = getOrganizationLogo(membership.institution);
                                                if (typeof logo === 'object' && logo.type === 'image') {
                                                    return <img src={logo.src} alt={logo.alt} className={membership.id === 10 ? "w-20 h-20 object-contain" : "w-10 h-10 object-contain"}/>;
                                                }
                                                return <span>{logo}</span>;
                                            })()
                                    }
                                </div>

                                {/* Content */}
                                <h4 className="text-base font-serif text-heritage-maroon mb-2 leading-tight">
                                    {membership.title}
                                </h4>
                                
                                <div className="text-primary-600 font-semibold mb-2 text-sm">
                                    {membership.institution}
                                </div>
                                
                                <p className="text-secondary-600 leading-relaxed text-xs">
                                    {membership.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Vision Statement */}
                <div className="text-center">
                    <div className="bg-white rounded-3xl p-8 shadow-soft max-w-4xl mx-auto">
                        <blockquote className="text-heading-md font-serif text-heritage-maroon italic mb-4">
                            "Knowledge is a lifelong journey. Through my work in Sanskrit and Jyotish, I strive to contribute to the preservation of India’s intellectual heritage while inspiring thoughtful inquiry and learning."
                        </blockquote>
                        <cite className="text-secondary-600 font-semibold">
                            — Prof. Bihari Lal Sharma, Vice Chancellor
                        </cite>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProfessionalCredentials;